import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

import { CONSTANT_VALUES } from '../constants/constant-values';
import { AppService } from '../app.service';
import { HttpInterceptor } from '../shared/index';
import { environment } from '../../environments/environment';
import { CONSTANT_MESSAGES } from '../constants/constants-messages';
import { UtilityFunctions } from '../shared/utility-functions';

@Injectable()
export class LoyaltyService {
  private _appService;
  private utilityFunctions = new UtilityFunctions();
  constructor(private http: HttpInterceptor, private appService: AppService) {
    this._appService = appService;
  }
 
  
  getMemberVisitStats(vendorObject) {
    try {
      let url = CONSTANT_VALUES.URL_MEMBER_VISIT_STATS;
      return new Promise((resolve, reject) => {
        this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }

  getMemberVisitDetails(vendorObject) {
    try {
      let url = CONSTANT_VALUES.URL_MEMBER_VISIT_DETAILS;
      return new Promise((resolve, reject) => {
        this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }

  updateTotalSpent(request) {
    try {
      let url = CONSTANT_VALUES.URL_MEMBER_VISIT_TOTAL_SPENT;
      return new Promise((resolve, reject) => {
        this.http.post(url, request).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/loyalty/loyalty.service.ts